
var $ = require('jquery');
var Backbone = require('backbone');

var ReservaTimeTableView = Backbone.View.extend({

	events: {
		'click .offset-down': 'offsetDown',
		'click .offset-up': 'offsetUp',
		'click .btn-reset': 'reset',
		'click .count-up': 'countUp',
		'click .count-down': 'countDown',
		'click tbody td': 'onClick',
		'mouseenter tbody td': 'onHover',
		'mousemove tbody td': 'onHover',
		'click .btn-start': 'start',
		'click .btn-stop': 'stop',
		'mouseleave tbody': 'resetStateClasses',
	},

	initialize: function() {
		this.listenTo(this.model, "change:viewData", this.render);
	},

	render: function() {
		this.el.innerHTML = TemplateCache.render('timetable-template', this.model.get("viewData"));
		this.model.trigger("rendered");
	},

	/*
	 Event Handler
	*/

	offsetDown: function(e) {
		var days = $(e.currentTarget).data('days') | 0;
		this.model.setRenderOffset(this.model.get("renderOffset") - days);
	},

	offsetUp: function(e) {
		var days = $(e.currentTarget).data('days') | 0;
		this.model.setRenderOffset(this.model.get("renderOffset") + days);
	},

	reset: function(e) {
		this.model.setRenderOffset(0);
	},

	countDown: function(e) {
		this.model.set("renderDaysCount", Math.max(10, this.model.get("renderDaysCount") - 5));
	},

	countUp: function(e) {
		this.model.set("renderDaysCount", this.model.get("renderDaysCount") + 5);
	},

	onHover: function(e) {
		var $e = $(e.currentTarget);
		var data = $(e.currentTarget).data();
		if ( typeof data.classOffset !== "undefined" && typeof data.dayOffset !== "undefined" ) {
			this.model.cellAction(data, $e, "hover");

			/* Hover for the current day */
			this.highlightDay(data.dayOffset);
		}
	},

	onClick: function(e) {
		var $e = $(e.currentTarget);
		var data = $(e.currentTarget).data();
		if ( typeof data.classOffset !== "undefined" && typeof data.dayOffset !== "undefined" ) {
			this.model.cellAction(data, $e, "click");
		}
	},

	start: function(e) {
		this.model.set("autoGo", true);
	},

	stop: function(e) {
		this.model.set("autoGo", false);
	},

	resetStateClasses: function(e) {
		this.$el.find('.day-hover').removeClass('day-hover');
	},

	/*
	 API
	*/

	highlightDay: function(dayOffset) {
		this.$el.find('.day-hover').removeClass('day-hover');
		this.$el.find('.day_' + dayOffset).addClass('day-hover');
	},

});

module.exports = ReservaTimeTableView;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/miniengine/ReservaTimeTableView.js